@if (visible()) {
	<div class="spinner-border {{ colorCls() }}" [style.width]="size()" [style.height]="size()" role="status">
		<span class="sr-only"></span>
	</div>
}
